import { useQuery } from "@tanstack/react-query"

import scheduleApi from "./scheduleApi"

const useReceivableDatesQuery = () => {
  const { data: result } = useQuery(["scheduleApi.receivableDates"], scheduleApi.receivableDates)
  const dates = result?.isSuccess ? result.data : null
  return dates
}

export default useReceivableDatesQuery
